import {RDV_ROUTES as rdvRoutes} from "~/api/routes";
import axios from 'axios'
export const state = () => ({
  historiques: null,
  details:null,
  pagination:{}
});

export const getters = {};

export const mutations = {
  HISTORIQUE_LOAD(state) {
    //state.isLoading = true;
    state.hasError = false;
    state.historiques = [];
    //state.page = page;
  },
  HISTORIQUE_SUCCES(state, historiques) {
    state.historiques = historiques;
    //state.pagination = params.payload.pagination;
    //state.filters = params.filters || state.filters;
  },
  HISTORIQUE_PAGINATION(state,pagination){
    delete pagination.data;
    state.pagination = pagination
  },
  HISTORIQUE_ERROR(state) {
    state.historiques = [];
    state.hasError = true;
  },
  HISTORIQUE_LOADED(state) {
    //state.isLoading = false;
  },
  HISTORIQUE_PROCESSING_START(state) {
    //state.isLoading = false;
  },
  HISTORIQUE_PROCESSING_END(state) {
    //state.isLoading = false;
  },
  HISTORIQUE_DETAILS_SUCCES(state,details) {
    state.details=details
    //state.isLoading = false;
  },
  REMOVE_HISTORIQUE_FROM_LIST(state, historique) {
    state.historiques = state.historiques.filter(element => element.id !== historique.id);
  },
  UPDATE_AN_HISTORIQUE(state, historique) {
    let index = state.historiques.findIndex((elem) => elem.id === historique.id);
    state.historiques = state.historiques.filter(element => element.id !== historique.id);
    state.historiques.splice(index, 0, historique);
  },
  ADD_HISTORIQUE_TO_LIST(state, historique){
    state.historiques.unshift(historique);
  }
};

export const actions = {
  async getHistoriques({commit},params={}) {
    commit('HISTORIQUE_LOAD');
    const queryUrl = {...rdvRoutes.list};
    queryUrl.endPoint += '&page=' +(params.page ? params.page : 1);
    this.$api.request(queryUrl,{},params)
      .then(response => {
        commit('HISTORIQUE_SUCCES', response.payload.data);
        commit('HISTORIQUE_PAGINATION', response.payload);
      })
      .catch(error => {
        commit('HISTORIQUE_ERROR');
      })
      .finally(() => commit('HISTORIQUE_LOADED'));
  },
  async getHistorique({commit}, params) {
    commit('HISTORIQUE_PROCESSING_START');
    await this.$api.request(historiqueRoutes.get,{id:params.id})
      .then(response => {
        commit('HISTORIQUE_DETAILS_SUCCES', response.payload);
      })
      .catch(error => {
        commit('HISTORIQUE_ERROR');
      })
      .finally(() => commit('HISTORIQUE_PROCESSING_END'));
  },
  async deleteHistorique({commit}, params) {
    commit('HISTORIQUE_PROCESSING_START');
    await this.$api.request(historiqueRoutes.delete, {id: params.id})
      .then(response => {
        //commit('HISTORIQUE_SUCCES', response);
        commit('REMOVE_HISTORIQUE_FROM_LIST', params);
      })
      .catch(error => {
        commit('HISTORIQUE_ERROR');
      })
      .finally(() => commit('HISTORIQUE_PROCESSING_END'));
  },
  async updateHistorique({commit}, params) {
    commit('HISTORIQUE_PROCESSING_START');
    await this.$api.request(historiqueRoutes.update, {id: params.id}, params)
      .then(response => {
        //commit('HISTORIQUE_SUCCES', response);
        commit('UPDATE_AN_HISTORIQUE', response.payload);
      })
      .catch(error => {
        commit('HISTORIQUE_ERROR');
      })
      .finally(() => commit('HISTORIQUE_PROCESSING_END'));
  },
  async createHistorique({commit}, params) {
    commit('HISTORIQUE_PROCESSING_START');
    await this.$api.request(historiqueRoutes.create, {}, params)
      .then(response => {
        //commit('HISTORIQUE_SUCCES', response);
        commit('ADD_HISTORIQUE_TO_LIST', response.payload);
      })
      .catch(error => {
        commit('HISTORIQUE_ERROR');
      })
      .finally(() => commit('HISTORIQUE_PROCESSING_END'));
  },
};
